import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  root: {
    flexShrink: 0,
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4)
  }
}));
